"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mask_1 = require("../mask");
var validator_1 = require("../validator");
var CustomMessage_1 = require("./CustomMessage");
var FieldCoreBase = /** @class */ (function (_super) {
    tslib_1.__extends(FieldCoreBase, _super);
    function FieldCoreBase(props) {
        var _this = _super.call(this, props) || this;
        _this.setFormSubmitted = function (submitted) {
            _this.setState({ submitted: submitted });
        };
        _this.resetState = function () {
            _this.setState({ submitted: false, showError: false });
        };
        _this.isValid = function () {
            return !_this.state.errorMessage && !_this.props.errorMessage;
        };
        _this.state = { showError: false, errorMessage: null };
        return _this;
    }
    Object.defineProperty(FieldCoreBase.prototype, "errorMessage", {
        get: function () {
            var errorProp = this.props.errorMessage;
            var _a = this.state, submitted = _a.submitted, showError = _a.showError, errorMessage = _a.errorMessage;
            return submitted || showError ?
                errorProp || errorMessage : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldCoreBase.prototype, "isRequired", {
        get: function () {
            return (this.props.validation || '').includes('required');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldCoreBase.prototype, "mask", {
        get: function () {
            var mask = mask_1.getMask(this.props.mask);
            if (!mask) {
                mask = { apply: function (v) { return v; }, clean: function (v) { return v; } };
                this.props.mask && console.warn("@react-form-fields/core: Mask '" + this.props.mask + "' not found");
            }
            return mask;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldCoreBase.prototype, "getMaskedValue", {
        get: function () {
            return this.mask.apply(this.props.value);
        },
        enumerable: true,
        configurable: true
    });
    FieldCoreBase.getDerivedStateFromProps = function (_a, currentState) {
        var name = _a.name, value = _a.value, validation = _a.validation, validationContext = _a.validationContext, validationAttributeNames = _a.validationAttributeNames, children = _a.children, submitted = _a.submitted;
        var customMessages = React.Children
            .toArray(children)
            .reduce(function (acc, child) {
            if (child.type === CustomMessage_1.default) {
                child.props.rules.split(',').forEach(function (rule) {
                    acc[rule] = child.props.children;
                });
            }
            return acc;
        }, {});
        var error = validator_1.validate(name, value, validation, validationContext, validationAttributeNames, customMessages);
        return tslib_1.__assign({}, currentState, { submitted: submitted !== undefined ? submitted : currentState.submitted, errorMessage: error.message });
    };
    return FieldCoreBase;
}(React.PureComponent));
exports.default = FieldCoreBase;
//# sourceMappingURL=FieldCoreBase.js.map